exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remover {\n  color: crimson;\n}\n\n.remover:hover {\n  font-size: 1.3em;\n  color: black;\n  cursor: default;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/listar-setores-cliente-processo/listar-setores-cliente-processo.component.css
// module id = ../../../../../src/app/processo/listar-setores-cliente-processo/listar-setores-cliente-processo.component.css
// module chunks = main